import { Injectable } from '@angular/core';
import { TrustAccount } from '@models/trustAccount';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './trustAccounts.actions';

@Injectable({
	providedIn: 'root',
})
export class TrustAccountDispatch {
	@Dispatch()
	Create = (trustAccount: TrustAccount): actions.Create =>
		new actions.Create(trustAccount);

	@Dispatch()
	Remove = (folderId: string): actions.Remove => new actions.Remove(folderId);

	@Dispatch()
	UpdateTrustAccount = (
		trustAccountId: string,
		trustAccount: Partial<TrustAccount>,
	): actions.UpdateTrustAccount =>
		new actions.UpdateTrustAccount({ trustAccountId, trustAccount });
}
